import { EntityType } from '@frontend/common';
import { ConstraintExtendedClient } from '@frontend/constraint/api';
import { constraintRequest } from '@frontend/constraint/events';
import { Constraint, ConstraintExtended } from '@frontend/constraint/types';
import { CommonMessage } from '@frontend/lang';
import React from 'react';

import { ReactiveDetailRegistryEntry } from '../../modal/reactive-detail-shell/reactive-detail.types';
import { ConstraintDetailsCard, ConstraintRuleSection } from './constraint-detail-sections';

export const constraintReactiveDetail: ReactiveDetailRegistryEntry<Constraint, ConstraintExtended> = {
    entityType: EntityType.CONSTRAINT,
    resolveFunction: constraintRequest,
    fetchExtended: ({ object, parents }) => ConstraintExtendedClient.fetchExtendedConstraint(object.account_id, parents.spot_id ?? object.spot_id, object.id),
    modalClassName: 'w-full xl:w-1/2 max-w-[900px]',
    title: ({ object, extended }) => (
        <div className='flex gap-1'>
            <span>{CommonMessage.OBJECTS.CONSTRAINT.DEFAULT}:</span>
            <span>{extended?.name ?? object.name}</span>
        </div>
    ),
    tabs: [
        {
            id: 'general',
            label: CommonMessage.DETAIL.GENERAL,
            render: (view) =>
                view.extended ? (
                    <>
                        <ConstraintDetailsCard constraint={view.extended} />
                        <ConstraintRuleSection constraint={view.extended} />
                    </>
                ) : null
        }
    ]
};
